import type { TFunction } from 'i18next';
import { RotateCcw } from '@tonnie/assets';
import type { KitTask } from './types';

export function RemovedTaskRow({
  task,
  onRestore,
  t,
}: {
  task: KitTask;
  onRestore: (code: string) => void;
  t: TFunction;
}) {
  return (
    <div className="flex items-center gap-2 px-2 py-1.5 rounded-md bg-muted/30">
      <span className="flex-1 text-xs text-muted-foreground line-through truncate">
        {t(task.task_name_key)}
      </span>
      <button
        type="button"
        onClick={() => onRestore(task.task_code)}
        className="shrink-0 flex items-center gap-1 text-2xs text-primary-accessible hover:text-primary-accessible/80 font-medium transition-colors"
      >
        <RotateCcw className="w-3 h-3" />
        {t('teleportal.kit.restore')}
      </button>
    </div>
  );
}
